/**
 *
 * @param key
 * @param featureFlagInfo
 */
export function getFeatureFlagInfoValue(key, featureFlagInfo) {
    return featureFlagInfo[key];
}
